import { ContentStatus } from '@confluence/page-utils/entry-points/enums';

type CheckIsChangeOwnerAvailableParams = {
	contentType?: string | null;
	contentStatus?: ContentStatus | string | null;
	isContentOwner: boolean;
	isSpaceAdmin: boolean;
};
export const checkIsChangeOwnerAvailable = ({
	contentType,
	contentStatus,
	isContentOwner,
	isSpaceAdmin,
}: CheckIsChangeOwnerAvailableParams): boolean => {
	if (!contentType || !contentStatus) {
		return false;
	}
	const isNotBlogpost = contentType !== 'blogpost';
	const isNotDraft = contentStatus !== ContentStatus.DRAFT;
	const isNotArchived = contentStatus !== ContentStatus.ARCHIVED;

	return isNotBlogpost && isNotDraft && isNotArchived && (isContentOwner || isSpaceAdmin);
};
